import { i18n } from "../../utils/i18n";
import { apiReceiveCoupon } from "../../services/coupon";
const bizflyUI = require("bizfly-ui").default;
const { Notification } = bizflyUI;

const state = {
  coupons: [],
  couponLoaded: false,
};

const getters = {
  coupons: (state) => {
    return state.coupons;
  },
  couponLoaded: (state) => {
    return state.couponLoaded;
  },
};

const mutations = {
  SET_COUPON(state, payload) {
    state.coupons = payload;
  },
  SET_COUPON_LOADED(state, status) {
    state.couponLoaded = status;
  },
};

const actions = {
  setCoupon({ commit }, payload) {
    commit("SET_COUPON", payload);
  },
  setCouponLoaded({ commit }, status) {
    commit("SET_COUPON_LOADED", status);
  },
  updateSingleCoupon({ commit }, coupon) {
    const mapedCoupons = state?.coupons?.map((c) => {
      if (c?.storage_id === coupon?.storage_id) {
        return coupon;
      }
      return c;
    });
    commit("SET_COUPON", mapedCoupons);
  },
  async receiveCoupon({ commit }, coupon) {
    actions?.updateSingleCoupon({ commit }, { ...coupon, receiving: true });
    try {
      await apiReceiveCoupon({ storage_id: coupon?.storage_id });
      Notification({
        title: i18n.t("coupon.couponReceivedTitle"),
        message: i18n.t("coupon.couponReceivedDes"),
        customClass: "success",
        type: "success",
      });
      actions?.hideCoupon({ commit }, coupon);
    } catch (error) {
      console.error(error);
      actions?.updateSingleCoupon({ commit }, { ...coupon, receiving: false });
      const msg =
        error?.response?.data?.message || "Nhận coupon không thành công";
      Notification({
        title: i18n.t("coupon.couponFailedTitle"),
        message: msg,
        customClass: "error",
        type: "error",
      });
    }
  },
  hideCoupon({ commit }, coupon) {
    const filterdCoupons = state?.coupons?.filter((c) => {
      return c?.storage_id !== coupon?.storage_id;
    });
    commit("SET_COUPON", filterdCoupons);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
